<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active' : showModal}" id="attendance-modal-template"
       role="dialog" aria-modal="true" aria-labelledby="cancel-modal-title">
    <div class="modal-wrap-container modal-wd1020" ref="modalContainer" tabindex="-1">
      <div class="modal-header">
        <div class="title" id="cancel-modal-title">강좌 취소 신청</div>
      </div>
      <div class="modal-body-container">
        <div class="table-wrap no-line-mg">
          <table class="table-body-only">
            <caption>취소사유</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">취소 사유</th>
                <td>
                  <div class="input-area wid100p">
                    <input type="text" ref="reason" v-model="reason" name="reason" placeholder="사유를 입력해주세요. (최대 300자)" maxlength="300" v-on:change="reasonChange" title="취소 사유"/>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <template v-if="type && type.toLowerCase() !== 'free'">
          <h5 class="title-type mt-40">환불규정 안내</h5>
          <div class="text-area-wrap mt-16">
            <p class="area-box__middle-section">학습비 반환사유는 학습자 본인의 의사로 수강 또는 학습장소 사용을 포기한 경우를 말합니다.</p>

                    <p class="area-box__middle-section">■ 환불 공통 유의사항</p>
                    <ul>
                      <li>환불기간은 환불신청일 다음날(당일 수강여부와 무관하게 익일)부터 산정됩니다.</li>
                      <li>신청자 본인 명의의 계좌로만 환불지급 가능합니다.</li>
                      <li>환불 지급 시기 : 환불 신청일 이후, 약 20일 내로 환불 처리됩니다.</li>
                      <li>환불금액은 수수료를 포함합니다.</li>
                      <li>교재비는 환불되지 않으며, 본인이 소장하셔야 합니다.</li>
                    </ul>

                    <p class="area-box__middle-section">■ 정규강좌 환불기준</p>
                    <div class="accent-box">
                    <p class="area-box__middle-section" style="margin-top: 0">1. 수강기간이 1개월 이내인 경우</p>
                    <ul>
                      <li>(1) 개강일이전 : 이미 납부한 수강료 전액</li>
                      <li>(2) 총 강의시간의 1/3 경과 전 : 이미 납부한 수강료의 2/3 해당 금액</li>
                      <li>(3) 총 강의시간의 1/2 경과 전 : 이미 납부한 수강료의 1/2 해당 금액</li>
                      <li>(4) 총 강의시간의 1/2 경과 후 : 반환하지 아니함.</li>
                    </ul>
                    <p class="area-box__middle-section">2. 수강기간이 1개월을 초과하는 경우</p>
                    <ul>
                      <li>(1) 개강일 이전 : 이미 납부한 수강료 전액</li>
                      <li>(2) 개강일 이후 : 환불 요청일 당해 월의 반환 수강료(1항목 기준)와 나머지 잔여 달의 학습비 전액을 합산한 금액</li>
                    </ul>
                    <p class="area-box__middle-section">3. 1일 특강 및 단기특강 * 개강일 이전까지만 전액환불 가능</p>
                    </div>

                    <p class="area-box__middle-section area-box__middle-section--under-title">위 사항은 '평생교육법 시행령(제23조제2항) '학습비 반환기준'에 따릅니다.</p>
                    <p class="area-box__middle-section">■ 별도 재료준비 및 예약사항이 있는 강좌</p>
                    <ul>
                      <li>강좌예시 : 여행강좌, 요리강좌 등</li>
                      <li>전액환불 가능기간 : 재료비(개강일 3일전까지), 숙박비(강좌 개시 7일전까지)</li>
                    </ul>
                    <p class="area-box__middle-section">■ 각 캠퍼스 및 센터를 방문하시면 더 자세한 안내를 받을 수 있습니다.</p>
                    <p class="area-box__middle-section">■ 단, 방문 시에도 인터넷 접수만 가능합니다.</p>
                    <ul>
                      <li>(상담센터 內 컴퓨터를 활용해 주세요)</li>
                    </ul>
                    <p class="area-box__middle-section">■ 카드결제 하신분들은 취소 요청함과 동시에 카드사에서 환불처리가 됩니다.<br/> 입력하신 은행계좌는 본인 확인용도 입니다. 감사합니다.</p>
          </div>

        <div class="table-wrap mt-40" v-if="!isCampusOrSenior">
          <table class="table-body-only">
            <caption>계좌정보 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">은행명</th>
                <td>
                  <div class="input-area wid100p flex">
                    <select placeholder="은행을 선택해주세요." v-model="bankCd" title="은행을 선택해주세요.">
                      <option value="" >은행 선택</option>
                      <option v-for="bank in bankList"
                              :key="bank.BANK_CD"
                              :value="bank.BANK_CD">
                        {{ bank.BANK_NM }}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">계좌번호</th>
                <td>
                  <div class="input-area wid100p flex">
                    <input type="number" placeholder="'-'를 빼고 숫자로만 계좌번호를 입력해주세요." ref="account" v-model="account" name="account" title="계좌번호(숫자만)"/>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">예금주</th>
                <td>
                  <div class="input-area wid100p flex">
                    <input type="text" placeholder="예금주를 입력해 주세요." ref="accntOwner" v-model="accntOwner" name="accntOwner" title="예금주성명"/>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">예금주생년월일 <br/>(주민번호앞6자리)</th>
                <td>
                  <div class="input-area wid100p flex">
                    <input type="number" placeholder="(ex : 700510)." ref="accntOwnerBirth" v-model="accntOwnerBirth" name="accntOwnerBirth" title="예금주 생년월일 6자리"/>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="input-area wid100p flex" style="justify-content: center;">
                    <button type="button" class="btn-file-upload" style="width:50%" @click="verifyAccount">본인계좌 인증하기</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="input-area wid100p flex" style="padding-top:10px">
            <span v-if="verifyChecked" :class="verifyClass"> {{ verifyYn ? '인증완료' : '미인증' }}</span><span v-if="verifyChecked" :class="verifyMsgClass">{{ verifyMsg }}</span>
          </div>
        </div>
        <div class="text-box-section mt-40" v-if="!isCampusOrSenior">
          * 환불 신청 시 작성된 계좌번호는 본인의 계좌임을 확인하며 계좌번호 오류에 따른 문제 발생 시 본 기관에서 책임지지 않습니다. 동의 하시겠습니까?
        </div>
        </template>

        <div class="yakguan-check-area mt-40" v-if="type && type.toLowerCase() !== 'free'">
          <ul>
            <li>
              <div class="check-wrap">
                <input type="checkbox" name="chkAddAgree" id="chkAddAgree" title="chkAddAgree 선택" />
                <label for="chkAddAgree"><span>확인</span></label>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150  close-modal" @click="close">
          닫기
        </button>
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="postCancel">
          신청
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'attendance-modal-template',
    props: ['showModal', 'courseId', 'type', 'orgSe', 'paymentType'],
    data() {
      return {
        bankList: [],
        bankCd: '',
        reason: '',
        bank: '',
        account: '',
        accntOwner: '',
        accntOwnerBirth: '',
        verifyYn: false,
        verifyMsgYn: false,
        verifyChecked: false,
        verifyMsg: '',
      };
    },
    methods: {
      reasonChange() {
        if (this.reason.length > 300) {
          alert(`취소사유는 300자 이하로 입력해주세요. 현재 ${this.reason.length}자 입니다.`);
          this.$refs.reason.focus();
        }
      },
      bankChange() {
        if (this.bank.length > 30) {
          alert(`취소사유는 30자 이하로 입력해주세요. 현재 ${this.bank.length}자 입니다.`);
          this.$refs.bank.focus();
        }
      },
      setButtons() {
        $('.course-cancel-btn').on('click', { thisVal: this }, (event) => {
          const varEvent = event;
          const IECheck = this.globalGetInternetExplorerVersion();

          if (this.courseId === null || this.courseId === '' || typeof this.courseId === 'undefined') {
            let courseId = '';
            let type = '';
            let orgSe = '';
            let paymentType = '';
            if (IECheck <= 10) {
              courseId = varEvent.currentTarget.getAttribute('data-courseId');
              type = varEvent.currentTarget.getAttribute('data-type');
              orgSe = varEvent.currentTarget.getAttribute('data-orgse') || '';
              paymentType = varEvent.currentTarget.getAttribute('data-paymenttype') || '';
            } else {
              courseId = varEvent.target.dataset.courseid;
              type = varEvent.target.dataset.type;
              orgSe = varEvent.target.dataset.orgse || '';
              paymentType = varEvent.target.dataset.paymenttype || '';
            }
            this.courseid = courseId;
            this.type = type;
            this.orgSe = orgSe;
            this.paymentType = paymentType;
          }

          this.close();

          $('body').addClass('modal-open');
          this.showModal = true;
        });
      },
      postCancel() {
        if (this.type && this.type.toLowerCase() === 'free') {
          this.account = '무료강좌';
        }
        if (this.isCampusOrSenior) {
          this.bank = '카드취소';
          this.bankCd = '';
          this.account = '카드취소';
        }
        if (this.type && this.type.toLowerCase() !== 'free' && !document.getElementById('chkAddAgree').checked) {
          alert('동의 체크를 해주세요.');
          document.getElementById('chkAddAgree').focus();
          return;
        }
        if (!this.reason) {
          alert('취소사유를 입력해 주세요.');
          this.$refs.reason.focus();
        } else if (this.reason.length > 300) {
          alert('취소사유는 300자 이하로 입력해주세요.');
          this.$refs.bank.focus();
        } else if (this.type && this.type.toLowerCase() !== 'free' && !this.isCampusOrSenior && !this.verifyYn) {
          alert('계좌인증을 진행해 주세요.');
          this.$refs.account.focus();
        } else {
          const result = window.confirm('정말 취소하시겠습니까?');
          if (result) {
            axios.put(`/api/courses/${this.courseId}/cancel`, {
              reason: this.reason,
              bank: this.bankNm,
              bankCd: this.bankCd,
              account: this.account,
              accntOwner: this.accntOwner,
              verifyYn: this.verifyYn,
              verifyMsg: this.verifyMsg,
            }).then(() => {
              this.reason = '';
              this.bank = '';
              this.bankCd = '';
              this.account = '';
              this.accntOwner = '';
              this.verifyYn = false;
              this.verifyMsg = '';
              alert('신청이 취소되었습니다.');
              $('body').removeClass('modal-open');
              location.reload();
            }).catch((error) => {
              const errorMsg = (error.response && error.response.data && error.response.data.msg) ||
                               (error.data && error.data.msg) ||
                               error.message ||
                               '오류가 발생했습니다.';
              alert(errorMsg);
            });
          }
        }
      },
      close() {
        this.showModal = false;
        this.reason = '';
        this.bank = '';
        this.bankCd = '';
        this.account = '';
        this.courseId = '';
        this.accntOwner = '';
        this.verifyYn = false;
        this.verifyMsg = '';
        this.orgSe = '';
        this.paymentType = '';
        this.$emit('update:courseCancelModal', false);
        $('.course-cancel-btn').focus();
        if (!document.getElementById('mypage-education-detail-template')) {
          $('body').removeClass('modal-open');
        }
      },
      timeFormat(time) {
        return `${time.slice(0, 2)}:${time.slice(2, 4)}`;
      },
      dateFormat(date) {
        return `${date.slice(0, 2)}.${date.slice(2, 4)}.${date.slice(4)}`;
      },
      loadBankList() {
        axios.post("/api/jb/app/getBankCodeList.do").then((res) => {
          this.bankList = res.data;
        }).catch((e) => {
          console.error(e);
        });
      },
      verifyAccount() {

        if (!this.bankCd) {
          alert("은행을 선택해주세요.");
          return;
        }

        // 2. 계좌번호 숫자만 추출
        const accountNo = this.account.replace(/-/g, '').trim();

        if (!/^\d{10,14}$/.test(accountNo)) {
          alert("계좌번호는 숫자 10~14자리여야 합니다.");
          return;
        }

        // 3. 생년월일 체크 (6자리)
        const birth = this.accntOwnerBirth.trim();

        if (!/^\d{6}$/.test(birth)) {
          alert("생년월일은 6자리 숫자로 입력해주세요.");
          return;
        }

        try {
          const queryParam = {
            "APP_NO": this.courseId,
            "acntNm": this.accntOwner,
            "acntNo": this.account,
            "bankCode": this.bankCd,
            "idNo": birth
          };
          const loginNm = window.memberInfo.name;
          axios.post("/api/jb/app/accountCheck.do", queryParam).then((res) => {
            const success = res.data.success;
            const resultCode = res.data.resultCode;
            const resultMsg = res.data.resultMsg || "인증 실패";
            const resultAcntNm = res.data.resultAcntNm;
            this.verifyChecked = true;
            if (success === "M") {
              alert("계좌 인증이 완료되었습니다.");
              if (resultCode === "0000") {
                if (resultAcntNm === loginNm) {
                  this.verifyYn = true;
                  this.verifyMsgYn = true;
                } else {
                  this.verifyYn = false;
                  this.verifyMsgYn = false;
                }
              } else {
                this.verifyYn = false;
                this.verifyMsgYn = false;
              }
            } else {
              alert(resultMsg || "계좌 인증 실패");
              this.verifyYn = false;
              this.verifyMsgYn = false;
            }
            this.verifyMsg = resultMsg;
          }).catch(err => {
            console.error(err);
          });
        } catch (e) {
          alert("인증 중 오류가 발생했습니다.");
        }
      },
      resolve() {
        if (this.type && this.type.toLowerCase() === 'free') {
          this.bankNm = "무료강좌/대기취소";
          this.account = "무료강좌/대기취소";
        } else {
          const found = this.bankList.find(
              b => b.BANK_CD === this.bankCd
          );
          this.bankNm = found ? found.BANK_NM : '';
        }
      }
    },
    watch: {
      // 모달이 열릴 때 취소 사유 입력창으로 포커스 이동
      showModal(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            if (this.$refs.reason) {
              this.$refs.reason.focus();
            } else if (this.$refs.modalContainer) {
              this.$refs.modalContainer.focus();
            }
          });
        }
      },
    },
    mounted() {
      this.setButtons();
      this.loadBankList();
      console.log(window.memberInfo);
      if (window.memberInfo) {
        this.accntOwner = window.memberInfo.name;
        this.accntOwnerBirth = window.memberInfo.birthdate;
      }
    },
    computed: {
      isCampusOrSenior() {
        return (this.orgSe === 'CAMPUS' || this.orgSe === 'SENIOR') && this.paymentType === 'CREDIT_CARD';
      },
      verifyClass() {
        return this.verifyYn
            ? 'verify-success'
            : 'verify-fail';
      },
      verifyMsgClass() {
        return this.verifyMsgYn
            ? 'verify-success'
            : 'verify-fail';
      },
      bankNm() {
        if (this.type && this.type.toLowerCase() === 'free') {
          return '무료강좌/대기취소';
        }
        const found = this.bankList.find(
            b => b.BANK_CD === this.bankCd
        );
        return found ? found.BANK_NM : "";
      },
    }
  };
</script>
<style scoped>
.verify-success {
  background-color: #3ab46b;
  font-weight: bold;
  color: #fff;
  padding: 8px;
}

.verify-fail {
  background-color: #d9534f;
  font-weight: bold;
  color: #fff;
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// CourseCancelButton.vue?2939fb2d